export default __webpack_public_path__ + "static/media/logoW.d0859f1d.png";